'use client'
const synonyms = {
    bitcoin: 'BTC',
    eip155: 'EVM',
    solana: 'SOL',
};
for (const chain in synonyms)
    synonyms[synonyms[chain]] = chain;
const compareChains = (chain1, chain2) => chain1 === chain2 || synonyms[chain1] === chain2;

export { compareChains };
